import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from 'antd';
import { getAuth } from 'firebase/auth';

import { CenteredLayoutContent } from '../../ui/components/layout';

const AuthAccessDisabledRoute = () => {
  const navigate = useNavigate();

  return (
    <CenteredLayoutContent title="Access Disabled" subtitle="Your account has been disabled">
      Please contact support to re-enable your account.
      <Button
        type="primary"
        size="large"
        block
        onClick={() => {
          getAuth().signOut();
          navigate({ to: '/auth/signin' });
        }}
      >
        Back to Sign In
      </Button>
    </CenteredLayoutContent>
  );
};

export const Route = createFileRoute('/auth/access-disabled')({
  component: AuthAccessDisabledRoute,
});
